import { Label, Tooltip, UIHeading4, UIText2 } from '@cian/ui-kit';

import { FC } from 'react';

import { Link } from 'shared/components/InteractiveTypography';
import { stopPropagation } from 'shared/utils/event/stopPropagation';

import styles from './CoworkingsBenefitsLabel.css';

type CoworkingsBenefitsLabelProps = {
  trackCoworkingInfoClick(): void;
  trackLabelClick(): void;
};

export const CoworkingsBenefitsLabel: FC<CoworkingsBenefitsLabelProps> = props => {
  const { trackLabelClick, trackCoworkingInfoClick } = props;

  return (
    <Tooltip
      arrow={false}
      placement="bottom"
      theme="white"
      title={
        <div className={styles['content']}>
          <UIHeading4>Коворкинг на 38% дешевле</UIHeading4>
          <div className={styles['description']}>
            <UIText2>Аренда коворкинга в первый год выгоднее обычного офиса</UIText2>
          </div>
          <Link href="https://promo.cian.ru/coworking" track={trackCoworkingInfoClick} onClick={stopPropagation}>
            Подробный разбор
          </Link>
        </div>
      }
    >
      <Label
        background="error_10"
        color="error_100"
        data-testid="publisher-labels.coworkings-benefits"
        onClick={trackLabelClick}
      >
        Это выгодно
      </Label>
    </Tooltip>
  );
};
